// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"2df3c1b6","87":"8c459868","380":"b1f20bd1","557":"05a3e2b9","890":"46ae9df2"}[chunkId] + ".chunk.js";
};